import { Route, Routes } from "react-router-dom";
import router from "./router";

function App() {
  return (
    <Routes>
      {router.map((route) => (
        <Route path={route.path} element={route.element} key={route.key} />
      ))}
    </Routes>
  );
}

export default App;
